import { Box, Button, useDialogState } from '@color/continuum';
import { UserRole, isUserAuthorized, useAuthContext } from '@color/lib';
import AddIcon from '@mui/icons-material/Add';

import { AddVariantDialog } from './AddVariantDialog';

export const VariantClassificationListButtons = () => {
  const { currentUser } = useAuthContext();
  const userIsVariantReviewerManager = isUserAuthorized(currentUser, {
    allowedRoles: [UserRole.VARIANT_REVIEWER_MANAGER],
  });
  const {
    openDialog: openAddVariantDialog,
    dialogIsOpen: addVariantDialogIsOpen,
    closeDialog: closeAddVariantDialog,
  } = useDialogState();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        margin: 1,
      }}
    >
      {userIsVariantReviewerManager && (
        <>
          <AddVariantDialog
            onDismiss={closeAddVariantDialog}
            dialogIsOpen={addVariantDialogIsOpen}
          />
          <Button
            variant="color-text"
            onClick={openAddVariantDialog}
            startIcon={<AddIcon />}
            size="small"
            sx={{ minWidth: 160 }}
          >
            Add Variant
          </Button>
        </>
      )}
    </Box>
  );
};
